import {BroadcastButton} from "./ez-alpine-cmp-broadcast-button.js";
import {ProducerStudioPreviewToolbar} from "./ez-alpine-cmp-producerstudio-preview-toolbar.js";
import {MediaDevicesButtons, ScreenshareButton} from "./ez-alpine-cmp-media-devices-buttons.js";
import {SessionStatus} from "./ez-alpine-cmp-session-status.js";

window.EzAlpine = {
  BroadcastButton,
  ProducerStudioPreviewToolbar,
  MediaDevicesButtons,
  ScreenshareButton,
  SessionStatus,
};